import { AssistantAvatarShape } from "@/ui/AssistantAvatar/assistantAvatarConfig";

/** Body outlines on the 120-unit canvas. Each keeps the face zone (y 50–85) inside its fill. */
export const CHARACTER_SHAPE_PATH: Record<AssistantAvatarShape, string> = {
	[AssistantAvatarShape.Blob]: "M60 12 C92 12 108 32 108 62 C108 92 90 108 60 108 C30 108 12 92 12 62 C12 32 28 12 60 12Z",
	[AssistantAvatarShape.Bean]: "M60 6 C90 6 100 30 100 60 C100 94 84 110 60 110 C36 110 20 94 20 60 C20 30 30 6 60 6Z",
	[AssistantAvatarShape.Drop]: "M60 4 C76 26 106 44 106 72 C106 96 86 110 60 110 C34 110 14 96 14 72 C14 44 44 26 60 4Z",
	[AssistantAvatarShape.Ghost]:
		"M18 60 C18 30 36 12 60 12 C84 12 102 30 102 60 L102 104 Q95 96 88 104 Q81 112 74 104 Q67 96 60 104 Q53 112 46 104 Q39 96 32 104 Q25 112 18 104 Z",
	[AssistantAvatarShape.Squircle]: "M60 14 C98 14 106 22 106 60 C106 98 98 106 60 106 C22 106 14 98 14 60 C14 22 22 14 60 14Z",
};
